module.exports = __webpack_public_path__ + "static/depoimentos-c923bd49eb617461e441d9d5b0e4b8b3.png";